<p>Listado de Heroes</p>

<h3 *ngIf='heroeBorrado; else noBorrado'>Heroe borrado: {{heroeBorrado}}</h3>

<ng-template #noBorrado>
    <h3>No ha borrado nada</h3>
</ng-template>

<button (click) = 'borrarHeroe()'>Borrar Heroe</button>

<ul>
    <li *ngFor="let heroe of heroes; let i = index">{{i+1}} - {{heroe}}</li>
</ul>